import { useEffect, useState } from "react";

const readVar = (name: string): number => {
  if (typeof window === "undefined") return 0;
  const value = getComputedStyle(document.documentElement).getPropertyValue(
    name
  );
  return parseFloat(value) || 0;
};

const readInsets = () => ({
  bottom: readVar("--safe-bottom"),
  top: readVar("--safe-top"),
});

// CSS env(safe-area-inset-*) 값을 px 단위 숫자로 노출.
// 회전 / iPad split view / 키보드로 인한 변화에 대응하기 위해 resize·orientationchange 에 재계산.
// 단순 padding/height 만 필요한 경우엔 CSS env() 또는 var(--safe-bottom) 을 직접 쓰는 게 더 효율적.
export default function useSafeAreaInsets() {
  const [insets, setInsets] = useState(readInsets);

  useEffect(() => {
    const update = () => setInsets(readInsets());
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
    };
  }, []);

  return insets;
}
